//import moment from 'moment';

export default function filters( $ ) {

	if($("#archive-filter").length > 0){


		$("body").on("click", "#archive-filter a:not(.active)", function(e){
			//e.preventDefault();
			//var filterPostType = $(this).parent().attr("filter-post-type");
			//var filterTax = $(this).parent().attr("filter-tax");
			//var filterTaxValue = $(this).attr("filter-tax-value");
			$(this).siblings().removeClass("active");
			$(this).addClass("active");
			//alert("hoi");

			//console.log(filterPostType, filterTax, filterTaxValue);

			//window.location.href = "/cases/?post_type="+filterPostType+"&tax="+filterTax+"&tax-value="+filterTaxValue;

		});

		$("body").on("click", "#archive-filter a.active", function(e){
			e.preventDefault();
			$(this).removeClass("active");
			//$(this).addClass("active");
			//alert("hoi");

			//console.log(filterPostType, filterTax, filterTaxValue);

			window.location.href = "/cases/";

		});
	}

}
